module.exports = __webpack_public_path__ + "media/images/lb/920-69bc9cc5492976a42b03699e665d9b18.svg";